import React from 'react';
import { Link } from 'react-router-dom';

function Navigation() {
    return (
        <>
            <ul>
                <li>
                    <Link to="/">Home</Link>
                </li>
                <li>
                    <Link to="/pupil-app">Pupil App</Link>
                </li>
                <li>
                    <Link to="/about-us">About</Link>
                </li>
                {/* Blog hidden for now
                <li>
                    <Link to="/news">News</Link>
                </li> */}
                <li>
                    <Link to="/contact">Contact</Link>
                </li>
            </ul>
        </>
    );
}

export default Navigation;
